import i18n from 'ar-i18n';
import { STRATEGY_ACTIVE_STATUSES, STRATEGY_INACTIVE_STATUSES } from '../actions.js';

export function transformPerformanceData(strategy, performanceRow, attributions) {
    let spend = 0,
        clicks = 0,
        impressions = 0,
        conversions = 0,
        gms = 0,
        name = i18n.gettext('Rakuten Campaign'),
        status = i18n.gettext('Pending');

    if (performanceRow) {
        ({spend, clicks, impressions} = performanceRow);
    }

    if (strategy) {
        if (STRATEGY_ACTIVE_STATUSES.includes(strategy.status)) {
            status = i18n.gettext('Active');
        }
        if (STRATEGY_INACTIVE_STATUSES.includes(strategy.status)) {
            status = i18n.gettext('Inactive');
        }
    }
    if (attributions) {
        gms = attributions.click_revenue;
        conversions = attributions.click_throughs;
    }
    return {
        date: 'date' in performanceRow && performanceRow.date ? performanceRow.date : null,
        eid: 'eid' in performanceRow && performanceRow.eid ? performanceRow.eid : null,
        status: status,
        name: name,
        spend: spend || 0,
        clicks: clicks || 0,
        impressions: impressions || 0,
        ecpc: clicks > 0 ? spend / clicks : 0,
        ctr: impressions > 0 ? clicks / impressions : 0,
        conversions: conversions,
        cvr: clicks > 0 ? conversions / clicks : 0,
        gms: gms,
        roas: spend > 0 ? gms / spend : 0,
        cpa: conversions > 0 ? spend / conversions : 0,
        aov: conversions > 0 ? gms / conversions : 0
    };
}

export function fixNaNHack(value) {
    if (isNaN(value)) {
        return 0;
    }
    return value;
}

export function renderCurrency(value, forCsv) {
    return forCsv ? i18n.numeral(fixNaNHack(value)).format('0') : i18n.numeral.formatCurrency(fixNaNHack(value));
}

export function renderNumber(value, forCsv) {
    let format = forCsv ? '0' : '0,0';
    return i18n.numeral(fixNaNHack(value)).format(format);
}

export function renderPercent(value) {
    return i18n.numeral(fixNaNHack(value)).format('0.00%');
}

export function renderDate(value) {
    return i18n.moment(value).utc().format('LL');
}

export function roundToInt(n, decimals = 0) {
    const multiplier = Math.pow(10, decimals);
    const roundedNum = Math.floor(n * multiplier + 0.5) / multiplier;
    if (decimals === 0) {
        return roundedNum;
    }

    return roundToInt(roundedNum, decimals - 1);
}
